/** @format */
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import {
    SortBySelect,
    SortBySelectProps,
} from '@toucan/client/features/search/components/sort-by-select';

import { DEFAULT_TEST_ID } from './constants';
import { styles } from './control-group.styles';

export type ControlGroupProps = SortBySelectProps & {
    'data-testid'?: string;
    className?: string;
    children?: ReactNode;
    setSearchFilterGroupMobileOpen: (value: boolean) => void;
    filtersAppliedCount: number;
};

export const StyledControlGroup = styled.div`
    ${styles}
`;

export const ControlGroup: FunctionComponent<ControlGroupProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    children,
    options,
    selectedOption,
    onSortByChange,
    filtersAppliedCount,
    setSearchFilterGroupMobileOpen,
    ...otherProps
}: ControlGroupProps) => {
    const { t } = useTranslation();

    return (
        <StyledControlGroup data-testid={dataTestId} {...otherProps}>
            <button
                data-testid={`${dataTestId}__filters-button`}
                className="control-group-item"
                onClick={() => {
                    setSearchFilterGroupMobileOpen(true);
                }}
            >
                <Trans components={{ 'bold-text': <strong /> }}>
                    {t('<bold-text>Filters:</bold-text> {{count}} applied', {
                        count: filtersAppliedCount,
                    })}
                </Trans>
            </button>
            <SortBySelect
                data-testid={`${dataTestId}__sort-by-select`}
                className="control-group-item"
                options={options}
                selectedOption={selectedOption}
                onSortByChange={onSortByChange}
            />
        </StyledControlGroup>
    );
};
